<template>
  <Splash class="Gamelist">
    <!-- <Overlay slot="overlay"></Overlay> -->

    <template slot="header">
      <h1>Gamelist</h1>
    </template>

    <template slot="caption">
      This is a list of currently active custom game lobbies on Warcraft III. New lobbies should appear within a few seconds. If you want to add this list to your Discord bot or website, see the <a href="/assets/docs/api.txt" target="_blank">API docs</a>. Clicking on a game will mark all games with the same map green and add it to your bookmarks.
    </template>

    <template slot="content">
      <modal
        name="bookmarks"
        width="800"
        height="820"
      >
        <h2 class="text-center mb-3">Bookmarked Maps</h2>
        <p class="tan w-75 m-auto">All bookmarked maps & games appear at the top of the list and are green.</p>

        <div class="mt-4 row">
          <div class="col-md-12 d-flex">
            <input
              type="text"
              class="small"
              placeholder="Map File or Game Name (e.x. Broken Alliances 6.0.w3x)"
              v-model="stagedBookmark"
            >

            <button
              class="small m-0 w-25"
              @click="toggleMark (stagedBookmark)"
            >Add Bookmark</button>
          </div>
        </div>

        <div class="mt-4 row">
          <template v-if="marked.length">
            <ul
              class="list-unstyled col-md-6"
              v-for="col in 2"
            >
              <template
                v-for="row in maxBookmarks / 2"
              >
                <li
                  class="Gamelist-bookmark"
                  v-if="marked.length > (col - 1) * maxBookmarks / 2 + (row - 1)"
                >
                  <span class="d-inline-block text-truncate pl-2">{{ marked [(col - 1) * maxBookmarks / 2 + (row - 1)] }}</span>
                  <i
                    class="fas fa-times red clickable link p-0"
                    @click="toggleMark (marked [(col - 1) * maxBookmarks / 2 + (row - 1)])"
                  ></i>
                </li>
                <li
                  class="Gamelist-bookmark"
                  v-else
                >
                  <div class="text-muted text-center w-100">Available</div>
                </li>
              </template>
            </ul>
          </template>

          <div
            class="red text-medium text-center w-100 m-2"
            v-else
          >
            No maps bookmarked.
          </div>
        </div>

        <div class="text-center">
          <button
            class="small w-50 m-0 mt-2"
            @click="$modal.hide ('bookmarks')"
          >Save</button>
        </div>
      </modal>

      <transition
        appear
        appear-active-class="fade-enter-active"
        v-if="loaded"
      >
        <div>
          <div class="row">
            <div class="col-lg-4 offset-lg-4 text-center">
              <input
                type="text"
                placeholder="Search"
                v-model="search"
                autofocus
              >

              <br>

              <img
                src="/assets/icons/book.png"
                class="Gamelist-icon clickable"
                v-tooltip="'View bookmarks.'"
                @click="$modal.show ('bookmarks')"
              >

              <img
                src="/assets/icons/bell-off.png"
                class="Gamelist-icon clickable"
                v-if="!soundOn"
                @click="soundOn = !soundOn"
                v-tooltip="'Play sound when a bookmarked game is hosted or becomes full.'"
              >

              <img
                src="/assets/icons/bell-on.png"
                class="Gamelist-icon clickable"
                v-else-if="soundOn"
                @click="soundOn = !soundOn"
                v-tooltip="'Turn off sounds.'"
              >

              <!-- <img
                src="/assets/icons/treasure-map.png"
                class="Gamelist-icon clickable"
                v-if="!detailsOn"
                @click="detailsOn = !detailsOn"
                v-tooltip="'Show game details.'"
              > -->

              <img
                src="/assets/icons/map-off.png"
                class="Gamelist-icon clickable"
                v-else-if="detailsOn"
                @click="detailsOn = !detailsOn"
                v-tooltip="'Hide game details.'"
              >

              <router-link :to="{ name: 'hosting' }">
                <img
                  src="/assets/icons/activity.png"
                  class="Gamelist-icon clickable"
                  v-tooltip="'View hosting activity.'"
                >
              </router-link>
            </div>
          </div>

          <div
            v-if="!detailsOn"
            class="row"
            style="margin-bottom: -80px"
          >
            <div
              class="col-sm-6"
              style="margin: 0 auto 80px auto;"
              v-for="server in [
                {
                  name: 'America',
                  games: america
                },

                {
                  name: 'Europe',
                  games: europe
                },

                {
                  name: 'Asia',
                  games: asia
                }
              ]"
            >
              <h1>{{ server.name }}</h1>
              <h3 :class="{ 'W3S-error' : server.games.length <= 0 }">{{ server.games.length }} {{ pluralize (server.games.length, 'Game') }} </h3>
              <Table v-if="server.games.length > 0">
                <thead>
                  <tr>
                    <th
                      v-for="(heading, key) in {
                        'slotsTaken' : 'Slots',
                        'name'       : 'Game Name',
                        'host'       : 'Host',
                        'created'    : 'Created'
                      }"
                      class="link"
                      :class="{
                        'pl-4'        : key === 'name',
                        'text-center' : key === 'slotsTaken'
                      }"
                      @click="
                        order *= sortBy === key ? -1 : 1;
                        sortBy = key;
                      "
                    >
                      {{ heading }}

                      <i class="fas fa-angle-up" v-if="sortBy === key && order === 1"></i>
                      <i class="fas fa-angle-down" v-if="sortBy === key && order === -1"></i>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="game in server.games"
                    class="clickable"
                    @click="toggleMark (game.map)"
                  >
                    <td class="pl-2">
                      <Icon
                        src="/assets/icons/map.png"
                        :size="26"
                        v-tooltip="game.map"
                      ></Icon>

                      {{ game.slotsTaken }} / {{ game.slotsTotal }}

                      <Bar
                        :fill="game.slotsTaken / game.slotsTotal * 100"
                      ></Bar>
                    </td>
                    <td
                      class="pl-4"
                      :class="{
                        'green' : bookmarked (game),
                        'orange' : !bookmarked (game)
                      }"
                    >
                      {{ game.name }}
                    </td>
                    <td><BattleTag :tag="game.host"></BattleTag></td>
                    <td>{{ timeago (game.created) }}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>

          <div
            v-else
            class="row"
          >
            <div class="col-12">
              <h3
                :class="{ 'W3S-error' : gamelistDetailed.length <= 0 }"
                class="mb-5 mt-3"
              >
                {{ gamelistDetailed.length }} {{ pluralize (gamelistDetailed.length, 'Game') }} With Details
                <div class="small text-muted mt-2">Powered by <a href="https://maps.w3reforged.com" target="_blank">maps.w3reforged.com</a></div>
              </h3>

              <div class="row">
                <div
                  class="col-lg-4 col-12 text-center"
                  v-for="game in gamelistDetailed"
                >
                  <div class="Gamelist-detailed">
                    <div class="Gamelist-detailed-inner">
                      <div class="d-flex flex-row">
                        <a
                          :href="game.details.urls.download"
                          target="_blank"
                        >
                          <img
                            class="Gamelist-minimap"
                            :src="game.details.urls.thumbnail"
                            width="128"
                            height="128"
                            v-tooltip="{ content: game.map, classes: [ 'tooltip', 'tooltip-nowrap' ] }"
                          >
                        </a>

                        <div class="Gamelist-detailed-content">
                          <strong>{{ game.name }}</strong>

                          <dl class="row mt-2">
                            <dt class="col-3">Host</dt>
                            <dd class="col-9"><BattleTag :tag="game.host"></BattleTag></dd>

                            <dt class="col-3">Author</dt>
                            <dd class="col-9">{{ game.details.author }}</dd>

                            <dt class="col-3">Slots</dt>
                            <dd class="col-9">{{ game.slotsTaken }} / {{ game.slotsTotal }}</dd>

                            <dt class="col-3">Created</dt>
                            <dd class="col-9">{{ timeago (game.created) }}</dd>
                          </dl>
                        </div>
                      </div>

                      <div class="text-muted small text-left" v-if="game.details.description">
                        {{ game.details.description }}
                      </div>
                      <div class="text-muted small" v-else>No description available.</div>

                      <a
                        :href="game.details.urls.download"
                        target="_blank"
                      >
                        <i class="Gamelist-detailed-download fa fa-download yellow" v-tooltip="'Download Map'"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>

      <template v-else>
        <div class="Loader"></div>
      </template>
    </template>
  </Splash>
</template>

<script>
  import Api from '@/legacy/lib//Api';

  import Splash from '@/legacy/components/layout/Splash';
import Bar from '@/legacy/components/widgets/Bar';
import BattleTag from '@/legacy/components/widgets/BattleTag';
import Collapser from '@/legacy/components/widgets/Collapser';
import Icon from '@/legacy/components/widgets/Icon';
import Table from '@/legacy/components/widgets/Table.vue';

  import { metaFactory, pluralize } from '@/legacy/lib//template';
import { inArrayI, timeago } from '@/legacy/lib//util';

  const states = {
    NOTIFIED_OPEN  : 0x01,
    NOTIFIED_READY : 0x02
  };

  export default {
    metaInfo () {
      return metaFactory ({
        title: 'Lobbies',
        description: 'Search the live Warcraft III gamelist. Lobbies are updated in near real-time.'
      })
    },

    components: {
      Splash,
      Table,
      Icon,
      Bar,
      BattleTag,
      Collapser
    },

    data () {
      return {
        loaded: false,
        gamelist: [],
        refreshTime: 5000,
        soundOn: false,
        // detailsOn: false,
        detailsOn: false,
        maxBookmarks: 32,
        stagedBookmark: '',
        notifications: {},

        audio: {
          gameOpen  : new Audio ('/assets/audio/GameOpen.mp3'),
          gameReady : new Audio ('/assets/audio/GameReady.mp3')
        },

        search : '',
        marked : [],
        sortBy : 'created',
        order  : -1,

        cacheKey: 'gamelist-marked'
      }
    },

    mounted () {
      let marked = localStorage.getItem (this.cacheKey);

      if (marked) {
        try {
          this.marked = JSON.parse (marked);
        } catch (e) {
          this.marked = [];
        }
      }

      this.audio.gameOpen.volume  = 0.5;
      this.audio.gameReady.volume = 0.25;

      this.refresh ();

      setInterval (() => {
        this.refresh ();
      }, this.refreshTime);
    },

    computed: {
      america () {
        return this.games ('usw');
      },

      europe () {
        return this.games ('eu');
      },

      asia() {
        return this.games ('kr');
      },

      filter () {
        return new RegExp (this.search, 'i');
      },

      gamelistDetailed () {
        let games = [];

        games = games.concat (this.america);
        games = games.concat (this.europe);

        return games.filter (g => g.details);
      }
    },

    methods: {
      timeago,
      pluralize,

      refresh () {
        Api
          .get ('/gamelist')
          .then (async (res) => {
            let json = await res.json ();

            if (json.code === 200) {
              this.gamelist = json.body;
              this.notify ();
            }
          })

          .catch (err => {
            console.log (err);
          })

          .finally (() => {
            this.loaded = true;
          });
      },

      games (server) {
        let games = this
          .gamelist
          .filter (g =>
            !server ||
            g.server === server &&
            (
              !this.search || (
                this.search && (
                  this.filter.test (g.name) ||
                  this.filter.test (g.map) ||
                  this.filter.test (g.host)
                )
              )
            )
          );

        games.sort ((g1, g2) => {
          if (this.bookmarked (g1)) {
            return -1;
          }

          if (this.bookmarked (g2)) {
            return 1;
          }

          return this.order * (g1 [this.sortBy] < g2 [this.sortBy] ? -1 : 1);
        });

        return games;
      },

      bookmarked (game) {
        let name;

        name = game.name.toLowerCase ();

        for (let mark of this.marked) {
          if (name.indexOf (mark.toLowerCase ()) !== -1) {
            return true;
          }
        }

        return inArrayI (game.map, this.marked);
      },

      toggleMark (map) {
        if (this.marked.includes (map)) {
          this.marked = this.marked.filter (m => m !== map);
        } else {
          this.marked.unshift (map);
        }

        this.marked = this.marked.slice (0, this.maxBookmarks);

        localStorage.setItem (
          this.cacheKey,
          JSON.stringify (this.marked)
        );
      },

      notify () {
        let ids = [];

        this
          .gamelist
          .filter (g => this.bookmarked (g))
          .forEach (g => {
            // Id needs to be a string for object.
            let id = '' + g.id;

            ids.push (id);

            if (g.slotsTaken === g.slotsTotal) {
              if (
                ! (id in this.notifications) ||
                ! (this.notifications [id] & states.NOTIFIED_READY)
              ) {
                if (this.soundOn) {
                  this.audio.gameReady.play ();
                }

                this.notifications [id] = states.NOTIFIED_OPEN | states.NOTIFIED_READY;
              }

              return;
            }

            if (
              ! (id in this.notifications) ||
              ! (this.notifications [id] & states.NOTIFIED_OPEN)
            ) {
              if (this.soundOn) {
                this.audio.gameOpen.play ();
              }

              this.notifications [id] |= states.NOTIFIED_OPEN;
            }
          });

        // Remove dangling ids in notificatons object.
        for (let gid in this.notifications) {
          if (! (ids.includes (gid))) {
            delete this.notifications [gid];
          }
        }
      }
    }
  };
</script>

<style lang="scss">
  .Body-main {
    background-color: rgba(var(--black), 1);
  }

  .Gamelist {
    // Other
    background-color: rgba(var(--black), 1);
    background: asset('background/orc-camp-repeatable.png')  no-repeat;
    background-size: 100% auto;

    h1,
    h3 {
      text-align: center;
    }

    h3 {
      font-size: 1.4rem;
      color: rgba(var(--yellow), 1);
    }

    &-icon {
      width: 60px;
      height: 60px;
      margin: 2rem 1rem;
    }

    &-bookmark {
      padding: 0.25rem 0;
      border-bottom: fetch(border faint);
      display: flex;

      &:first-child {
        border-top: fetch(border faint);
      }

      span {
        margin-right: auto;
      }

      i {
        margin-right: 1rem;
        margin-top: 0.2rem;
      }
    }

    &-minimap {
      width: 128px;
      height: 128px;
    }

    .Table {
      margin-top: 3rem;
      padding: 0 2rem;

      th,
      td {
        text-align: left;
      }
    }

    &-detailed {
      padding: 1rem 0;
      height: 100%;

      &-inner {
        padding: 1rem;
        height: 100%;
        border: fetch(border faint);
        background-color: rgba(var(--white), .05);
        position: relative;
      }

      &-content {
        dl {
          margin: 1rem;
        }

        dt,
        dd {
          font-size: .8rem;
        }
      }

      &-download {
        position: absolute;
        top: 1.1rem;
        right: 1.1rem;
      }
    }
  }

  .fade-enter-active {
    animation: go 1s;
  }

  @keyframes go {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
</style>
